import { Box } from '@vouched.id/vault';
import React from 'react';
import { Dropdown } from '../Dropdown';
import { JobErrorMessage } from '../utils';
import { CrossCheckCaption } from './CrossCheckCaption';
import { CrossCheckCompletedResult } from './CrossCheckCompletedResult';
export const CrossCheckDropdowns = ({ crossCheckResult, jobErrors, jobStatus, crossCheckSubmittedData }) => {
    if (!crossCheckResult) {
        return (React.createElement(Dropdown, { title: "CrossCheck" },
            React.createElement(Box, null,
                React.createElement(CrossCheckCaption, null),
                React.createElement(JobErrorMessage, { typeName: "CrossCheck" }))));
    }
    return (React.createElement(CrossCheckCompletedResult, { crossCheckResult: crossCheckResult, crossCheckSubmittedData: crossCheckSubmittedData, jobErrors: jobErrors, jobStatus: jobStatus }));
};
